import { Icons, Images } from "assets";
import classNames from "classnames";
import CustomModal from "shared/components/common/customModal";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import styles from "./style.module.scss";

interface Props extends ModalProps {
  detail: ReportedUserDetail | null;
}

const ReportedUserDetailsModal = ({ detail, show, handleClose }: Props) => {
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={styles.modalTitle}>Report Details</h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              handleClose();
            }}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-2")}
        >
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Reason</h4>
            <p className="">{detail?.reason || "N/A"}</p>

            <h4>Description</h4>
            <p className="">{detail?.desc || "N/A"}</p>

            {detail?.image?.fullpath ? (
              <>
                <h4>Proof</h4>
                <div>
                  <img
                    src={detail?.image?.fullpath}
                    alt=""
                    style={{
                      height: "300px",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </>
            ) : null}
          </div>
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Reported User</h4>
            <div className="flex items-center justify-center my-2">
              <div className={classNames(styles.imgContainer)}>
                <img
                  src={
                    detail?.user?.profile_image?.fullpath
                      ? detail?.user?.profile_image?.fullpath
                      : Images.DefaultAvatar
                  }
                  alt=""
                />
              </div>
            </div>
            <p className="">
              <strong>Name:</strong> {detail?.user.name || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.section, "mb-4 flex flex-col gap-2")}
          >
            <h4>Reported By</h4>
            <div className="flex items-center justify-center my-2">
              <div className={classNames(styles.imgContainer)}>
                <img
                  src={
                    detail?.reported_by?.profile_image?.fullpath
                      ? detail?.reported_by?.profile_image?.fullpath
                      : Images.DefaultAvatar
                  }
                  alt=""
                />
              </div>
            </div>
            <p className="">
              <strong>Name:</strong> {detail?.reported_by.name || "N/A"}
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default ReportedUserDetailsModal;
